import { MixinsWithHelpers } from './'

export function createShape(utils: MixinsWithHelpers, { borderRadius }) {
  return {
    borderRadius: (times = 1) => {
      return utils.getSize(borderRadius * times, { forceUnit: true })
    },
  }
}
